import { Box, styled } from '@mui/material';

const ButtonWrapper = styled(Box)`
  width: 100%;
  justify-content: flex-end;
  display: flex;
  gap: 20px;
`;

export default ButtonWrapper;
